(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/horse-profile.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/horse-profile.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  memo
} = React;
const {
  Link
} = ReactRouterDOM;
const {
  useNavigationState
} = svs.racing.navigation;
const {
  Image
} = svs.content.image_v2;
const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const {
  buildCouponLocation
} = svs.racing.navigation.location;
const HorseProfile = _ref => {
  let {
    participant,
    silksFormattedDate,
    isSelected
  } = _ref;
  const itemClasses = ['horse-profile-item', isSelected ? 'selected' : ''];
  const canceledClass = participant.canceled ? 'canceled' : '';
  const navState = useNavigationState();
  const imageOptions = (participant === null || participant === void 0 ? void 0 : participant.silks) && silksFormattedDate && getImageOptions(participant.silks, silksFormattedDate, ImageTypes.StatisticsSilk);
  return React.createElement(Link, {
    to: buildCouponLocation(_objectSpread(_objectSpread({}, navState), {}, {
      participantName: participant.horseNameUrl,
      participantId: participant.participantId,
      statisticsMenuItem: undefined
    }))
  }, React.createElement("div", {
    className: "".concat(itemClasses.join(' '))
  }, React.createElement("div", {
    className: "horse-profile-dress"
  }, imageOptions && React.createElement(Image, {
    image: imageOptions
  })), React.createElement("div", {
    className: "horse-profile-description ".concat(canceledClass)
  }, React.createElement("div", {
    className: "horse-profile-horse-name f-550"
  }, participant.participantNumber, ".\xA0", participant.horseName), React.createElement("div", {
    className: "horse-profile-driver-name"
  }, participant.driverName))));
};
svs.racing_game.components.statistics.HorseProfile = memo(HorseProfile);

 })(window);